import { render, staticRenderFns } from "./BSSignHoursModal.vue?vue&type=template&id=56cbafe4"
import script from "./BSSignHoursModal.vue?vue&type=script&lang=js"
export * from "./BSSignHoursModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports